import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const TabItem = ({to, mobile, label, count}) => {
  return (
    <NavLink
      to={to}
      className={`cursor-pointer border-primary opacity-50 ${mobile ? `p-3 text-center` : `pb-4 mr-12`}`}
      activeClassName="border-b-4 opacity-100"
    >
      <div className="flex items-center text-sm lg:text-base uppercase">
        <p className="mr-1 font-bold font-accent">
          {label}
        </p>
        <p className="font-accent font-normal">
          ({count})
        </p>
      </div>
    </NavLink>
  )
}

const ListNav = ({rawData, data, mobile, countData}) => {
  // const getCount = (key) => {
  //   return data ? data.length : rawData[key] ? rawData[key].length : null
  // }

  const searchQueryString = useSelector(state => state.search.queryString)

  const tabItems = [
    {
      label: "Program",
      route: "/program"
    },
    {
      label: "Organization",
      route: "/organization"
    },
    {
      label: "Event",
      route: "/event"
    },
    {
      label: "Resources",
      route: "/resource"
    },
    {
      label: "Blog",
      route: "/blog"
    }
  ]

  return (
    <div className="flex overflow-x-auto border-b mb-5 lg:mb-8">
      {
        tabItems.map(t => (
          <TabItem
            key={t.label}
            mobile={mobile}
            label={t.label}
            // count={getCount(`/search-results${t.route}`)}
            count={countData[t.route]}
            to={`/search-results${t.route}${searchQueryString}`}
          />
        ))
      }
    </div>
  )
}

export { ListNav }
